import $ from 'jquery';
import { isEqual } from 'lodash/fp';
import * as Sentry from '@sentry/browser';

import '~/styles/main.scss';

import { subscribeOn } from '~/state/bridge';
import CampaignClient from '~/state/Campaign/client';
import { getCurrentAgentIdString } from '~/state/Agents/selectors';
import { getLeadAdEnabled, getSelectedForm } from '~/state/LeadAds/selectors';
import {
  getCampaignName,
  getSelectedInstagramId,
  getEndCardEnabled,
  getAdName,
  getAdType,
} from '~/state/Campaign/selectors';
import { deriveFBTargetingSpec } from '~/state/Targeting/selectors';
import { getRGAdPlacementArray } from '~/state/AdPlacement/selectors';

import { jax } from '~/api/core/legacy';
import { dispatch as emit } from '~/emitter';

import { render, querySubscription } from '~/theseus';
import Scheduler from '~/theseus/components/AdBudget/Scheduler';
import {
  AdPlacement,
  AdTypePicker,
  PostButton,
  PotentialReach,
} from '~/theseus/components/Campaign';
import Targeting from '~/theseus/components/Targeting';
import AgentAlert from '~/theseus/components/AgentAlert';
import InstagramSelector from '~/theseus/components/InstagramSelector';

import { lb, prompt_leave } from '../shared/lightbox';

import { getServerUrl as get_server_url } from '~/api/core/utils';
import { deleteCookie } from '~/utils';

const params = (() => {
  const _params = new URL(window.location).searchParams;

  /* eslint-disable */
  const paramObj = {};
  for (const [key, value] of _params.entries()) {
    paramObj[key] = value;
  }
  /* eslint-enable */

  return paramObj;
})();

const override_lookup = {
  alert_status: {
    ACTIVE: 'Active',
    __GRAY__: 'Under Contract',
    SOLD: 'Sold',
  },
};

let ad_images = 'carousel';
let end_card = true;
/* eslint-disable */
let ad_schedule_toggle = 'all';
let ad_schedule = null;
/* eslint-enable */

let currentTargetingState = null;
let placementOptions = [true, true, false, true, false, false];
let ad_type = 'boosted';
let instagram_actor_id = null;
let leadAdEnabled = false;
let leadFormId = '';
let agentId = '';
let accountId = null;

/*
 * These are all of the potential google analytic cookies that could be present
 * in the window. We go ahead and remove all of them to prevent headaches later on
 */
[
  '__utmzz',
].map(deleteCookie('.realgeeks.com', '/'));

// We need ad name to ensure that user supplies ad name if they
// are using a lead ad
let adName = '';
let campaignName = '';

subscribeOn(deriveFBTargetingSpec, (state) => { currentTargetingState = state; });
subscribeOn(getRGAdPlacementArray, (options) => { placementOptions = options; });
subscribeOn(getSelectedInstagramId, (id) => { instagram_actor_id = id; });
subscribeOn(getAdType, (type) => {
  ad_type = type;
  switch (type) {
    case 'post_only': {
      $('.campaign').slideUp('fast');
      break;
    }
    case 'boosted':
    case 'ad_only': {
      $('.campaign').slideDown('fast');
      break;
    }
    default: break;
  }
});

const $leadAdOptions = `
  <option value='LEARN_MORE' selected>Learn More</option>
  <option value='SIGN_UP'>Sign Up</option>
`;

const $defaultOptions = `
  <option value='NO_BUTTON' selected>No Button</option>
  <option value='SHOP_NOW'>Shop Now</option>
  <option value='LEARN_MORE'>Learn More</option>
  <option value='SIGN_UP'>Sign Up</option>
  <option value='DOWNLOAD'>Download</option>
  <option value='WATCH_MORE'>Watch More</option>
  <option value='CONTACT_US'>Contact Us</option>
`;

const $defaultObjectives = `
  <option value='OUTCOME_LEADS:COMPLETE_REGISTRATION' selected>Conv. Sign Ups</option>
  <option value='OUTCOME_LEADS:LEAD'>Conv. Seller Sign Ups</option>
  <option value='OUTCOME_TRAFFIC'>Website Clicks</option>
`;

const $leadAdObjectives = `
  <option id="lead-gen-objective" value="OUTCOME_LEADS" selected>Lead Generation</option>
`;

subscribeOn(getLeadAdEnabled, (isEnabled) => {
  if (isEnabled) {
    $('#campaign-cta')
      .empty()
      .append($leadAdOptions);

    $('#campaign-objective')
      .empty()
      .append($leadAdObjectives)
      .attr('disabled', 'disabled');
  } else {
    const $ctaSelect = $('#campaign-cta');
    // Disabling leadAds will also reset the selected form to null
    $ctaSelect
      .empty()
      .append($defaultOptions)
      .val('NO_BUTTON');

    $('#campaign-objective')
      .empty()
      .append($defaultObjectives)
      .removeAttr('disabled');
  }

  leadAdEnabled = isEnabled;
});
subscribeOn(getSelectedForm, (id) => { leadFormId = id || ''; });
subscribeOn(getCurrentAgentIdString, (id) => { agentId = id; });
subscribeOn(getCampaignName, (name) => { campaignName = name; });
subscribeOn(getAdName, (name) => { adName = name; });
subscribeOn(getEndCardEnabled, (endCardEnabled) => { end_card = endCardEnabled; });

querySubscription('account_id', (id) => { accountId = id; });


// The queryKey is extracted lazily since accountId will change and we want to
// ensure that we listen for the right fb_pixel
let fb_pixel = null;
querySubscription(() => ['facebook-pixel', accountId], (newPixel) => {
  fb_pixel = newPixel;
});

export function addMountPoint(selector) {
  $(selector).before('<div id="mount-react" class="collage collage--enabled"></div>');
}

const publish_dom = `
  <div id=publish_dom>
    <div id='ad-type-selection'></div>
    <div id="targeting"></div>
    <div id="lead-ads"></div>
    <form id='publish_ad' action='' class='campaign campaign--hidden'>
      <div class='campaign__header'>
        <h2>Campaign Options</h2>
      </div>
      <div class='campaign__container'>
        <div class='campaign__row'>
          <div class='campaign__field'>
            <label for='choose-budget'>Spend <span>$</span></label>
            <input id='choose-budget' type='number' placeholder='100' min='2'>
            <label for='choose-budget'>Per Day</label>
          </div>
          <div class='campaign__field'>
            <label for='campaign-length'>Run for</label>
            <input id='campaign-length' type='number' placeholder='3' min='2'>
            <label for='campaign-length'>Days</label>
          </div>
        </div>
        <div class='campaign__advanced'>
          <button class='campaign__advanced-toggle' type='button'>Show Advanced Options</button>
          <span class='campaign__advanced-description'></span>
          <div id='campaign__advanced-main' class='campaign__advanced-container hide'>
            <div class='campaign__schedule'>
              <h3>Ad Scheduling</h3>
              <div class='campaign__schedule-fields'>
                <div class='field'>
                  <input id='check-all-time' type='radio' name='schedule-option'/>
                  <label for='check-all-time'>Run ads all the time</label>
                </div>
                <div class='field campaign__schedule-field'>
                  <input id='check-schedule' type='radio' name='schedule-option'/>
                  <label for='check-schedule'>Run ads on a schedule</label>
                </div>
              </div>
              <div id='schedule-grid'></div>
            </div>
            <div class='campaign__options'>
              <div id="placement-options"></div>
              <div class='campaign__objective'>
                <h3>Campaign Objective</h3>
                <div class='campaign__field'>
                  <select id='campaign-objective' name='campaign-objective' >
                    <option value='OUTCOME_LEADS:COMPLETE_REGISTRATION'>Conv. Sign Ups</option>
                    <option value='OUTCOME_LEADS:LEAD'>Conv. Seller Sign Ups</option>
                    <option value='OUTCOME_TRAFFIC'>Website Clicks</option>
                  </select>
                </div>
              </div>
              <div class='campaign__cta'>
                <h3>CTA Dropdown</h3>
                <div class='campaign__field'>
                  <select id='campaign-cta' name='campaign-cta' >
                    <option value='NO_BUTTON'>No Button</option>
                    <option value='SHOP_NOW'>Shop Now</option>
                    <option value='LEARN_MORE'>Learn More</option>
                    <option value='SIGN_UP'>Sign Up</option>
                    <option value='DOWNLOAD'>Download</option>
                    <option value='WATCH_MORE'>Watch More</option>
                    <option value='CONTACT_US'>Contact Us</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="instagram-selector"></div>
      </div>
    </form>
    <div class='button-group button-group--disabled'>
      <div id="campaign-name"></div>
      <div id="post-button"></div>
      <div id='agent-alert'></div>
      <div class='terms-and-conditions'>Please remember you have agreed to our <span id="open-terms">terms and conditions</span> and won't post others' listings without their permission.</div>
    </div>
  </div>
`;

export function publishControlsNoAudience() {
  CampaignClient.ad.changeType('post_only');
  $('#publish_ad').remove();
}

export function publishControls(parent, post_specific_ad, linkType) {
  const $dom = $(publish_dom);

  if ($('body').hasClass('dashboard')) {
    $dom.find('.campaign__options').addClass('campaign__options--dashboard');
  }

  function updateSchedule(schedule) {
    ad_schedule = schedule;
  }

  function ad_schedule_set(v) {
    if (v == 'all') {
      $('#check-all-time').attr('checked', true);
      $('.schedule').addClass('schedule--inactive');
    } else if (v == 'schedule') {
      $('#check-schedule').attr('checked', true);
      $('.schedule').removeClass('schedule--inactive');
    }
    ad_schedule_toggle = v;
  }

  if ($('#publish_dom').length === 0) {
    $(parent).append($dom);

    render('#ad-type-selection', <AdTypePicker hideEndCard={['video', 'single'].some(isEqual(linkType))} />);
    render('#targeting', <Targeting />);
    render('#placement-options', <AdPlacement />);
    if ($('#potential-reach').length > 0) {
      render('#potential-reach', <PotentialReach />);
    }
    render('#instagram-selector', <InstagramSelector />);
    render('#agent-alert', <AgentAlert />);
    render('#post-button', <PostButton onPost={post_specific_ad} />);
    render('#schedule-grid', <Scheduler onChange={updateSchedule} />);
    $('#choose_audience_field').remove();
    $('#open-terms').click(() => {
      emit({ type: 'open-tos' });
    });
  }

  let showing_advanced = false;
  $('.campaign__advanced-toggle').on('click', (e) => {
    if (!showing_advanced) {
      showing_advanced = true;
      $(e.target).html('Hide Advanced Options').addClass('campaign__advanced-toggle--showing');
      $('#campaign__advanced-main').removeClass('hide').hide().slideDown('fast')
        .css('display', 'flex');
    } else {
      showing_advanced = false;
      $(e.target).html('Show Advanced Options').removeClass('campaign__advanced-toggle--showing');
      $('#campaign__advanced-main').slideUp('fast').addClass('hide');
    }
  });
  ad_schedule_set(ad_schedule_toggle);
  const $schedule = $(`
    <div class=schedule-alert>
      This ad has a <strong>lifetime budget</strong> of <span class=schedule-alert__cost></span>
    </div>
  `);
  $('#check-all-time').on('change', () => {
    ad_schedule_set('all');
    $schedule.remove();
  });
  $('#check-schedule').on('change', () => {
    function update() {
      const cost = $('#choose-budget').val() * $('#campaign-length').val();

      $schedule.find('.schedule-alert__cost').html(cost);
    }
    update();
    $('#choose-budget').on('keyup change', (e) => {
      CampaignClient.ad.setBudget(e.target.value);
    });
    $('#campaign-length').on('keyup change', (e) => {
      CampaignClient.ad.setAdLength(e.target.value);
    });
    ad_schedule_set('schedule');
    $('.campaign__schedule h3').after($schedule);
  });
}

function set_ad_images(v) {
  if (v == 'carousel') {
    $('#check-carousel').attr('checked', 'checked');
    $('.image-picker__creatives-container').removeClass('image-picker__creatives-container--hidden');
    $('.ad-type__check-end-card').show();
  } else if (v == 'album') {
    $('#check-album').attr('checked', 'checked');
    $('.image-picker__creatives-container').addClass('image-picker__creatives-container--hidden');
    $('.ad-type__check-end-card').hide();
  }
  ad_images = v;
}

$('#check-album').on('change', () => { set_ad_images('album'); });

$('#check-carousel').on('change', () => { set_ad_images('carousel'); });

set_ad_images(ad_images);

$('.link__input').focus();

export function add_tag(key, value, $active) {
  if ($active) {
    const p = $active.get(0).selectionStart;
    const end = $active.get(0).selectionEnd;
    if (p != end) {
      const origin_text = $active.val();
      const selected_text = origin_text.substring(p, end);
      $active.val(origin_text.replace(selected_text, ''));
    }
    let tag_text = '';
    if (key != null) {
      tag_text += `[${key}]`;
    }
    if (value != null) {
      tag_text += value;
    }
    const current_value = $active.val();
    const before = current_value.substring(0, p);
    const after = current_value.substring(p);
    if (before.length != 0 && before.slice(-1) != ' ') {
      if (before.charAt(before.length - 1) != '\n') {
        tag_text = ` ${tag_text}`;
      }
    }
    if (after.length != 0 && after.charAt(0) != ' ') {
      tag_text += ' ';
    }
    const new_p = p + tag_text.length;
    $active.val(before + tag_text + after);
    $active.focus();
    $active.get(0).setSelectionRange(new_p, new_p);
    $active.trigger('keyup');
  }
}

$('.link__container').on('submit', prompt_leave);

export function post_ad(type, linkType, more_data, url, account_id, page_id, campaign_objective) {
  let send_ad_schedule = null;
  let ad_campaign_objective = $('#campaign-objective').val();
  const ad_campaign_cta = $('#campaign-cta').val();
  const data = {
    account_id,
    page_id,
    override_lookup: JSON.stringify(override_lookup),
    end_card,
    name: campaignName,
    call_to_action: ad_campaign_cta,
    lead_ad_enabled: leadAdEnabled,
  };
  const ad_campaign_budget = $('#choose-budget').val();
  const ad_campaign_length = $('#campaign-length').val();
  if (campaign_objective != null) { ad_campaign_objective = campaign_objective; }
  /* eslint-disable */
  for (const k in more_data) {
    data[k] = more_data[k];
  }
  /* eslint-enable */

  if (linkType !== 'multi_custom' && linkType !== 'video' && linkType !== 'single') {
    data.agent_id = agentId;
  }

  if (ad_schedule_toggle == 'schedule') {
    send_ad_schedule = ad_schedule;
  } else if (ad_schedule_toggle == 'all') {
    send_ad_schedule = null;
  }

  if (adName.length === 0) {
    alert('Please supply a name for your ad');
    return false;
  }

  if (ad_type == 'boosted' || ad_type == 'ad_only') {
    if (!ad_campaign_budget || !ad_campaign_length) {
      alert('Please add a daily budget and length before trying to create an ad');
      return false;
    }
    if (ad_campaign_budget < 2) {
      alert('You must spend a minimum of $2 per day to create an ad.');
      return false;
    }
    if (ad_campaign_length < 2) {
      alert('You must run your campaign for a minimum of 2 days to create an ad');
      return false;
    }
    // Without a pixel the ad would be created but silently retry publication
    // until it goes futile; catch it before creation and offer the
    // one-click fix instead.
    if (!fb_pixel) {
      if (window.confirm(
        'This ad account does not have a Facebook pixel set up yet, so ads cannot publish. Set it up now?',
      )) {
        jax(
          'setup_fb_pixel',
          { account_id: accountId },
          (r) => {
            fb_pixel = r.pixel_id;
            alert('Your pixel is set up! Click again to create your ad.');
          },
          (r) => {
            alert('We could not set up your pixel automatically. Please contact support.');
            Sentry.captureException(r);
          },
        );
      }
      return false;
    }
  }

  if (url == null) {
    if (ad_images == 'carousel') {
      url = `create_post_${type}_carousel`;
    } else {
      url = `create_post_${type}_album`;
    }
  }

  const targeting = JSON.stringify(currentTargetingState);

  if (ad_type == 'boosted' || ad_type == 'post_only') {
    jax(
      url,
      data,
      (r) => {
        if (ad_type == 'boosted') {
          jax(
            'create_ad_post',
            {
              page_id,
              account_id,
              fb_pixel_id: fb_pixel,
              post_id: r.post_id,
              link: ' ',
              daily_dollar: ad_campaign_budget,
              days: ad_campaign_length,
              targeting,
              name: campaignName,
              placement_options: JSON.stringify(placementOptions),
              schedule: JSON.stringify(send_ad_schedule),
              objective: leadAdEnabled ? 'OUTCOME_LEADS' : ad_campaign_objective,
              lead_ad_enabled: leadAdEnabled,
              lead_form_id: leadFormId,
              instagram_actor_id,
            },
            (rr) => {
              lb('Your Post Was Created and Boosted', 'success', r.post_id, rr.campaign_id, true, true);
              FB.AppEvents.logEvent('boosted_post_created', null, {
                ad_campaign_budget: Number(ad_campaign_budget),
                ad_campaign_length: Number(ad_campaign_length),
                total_spend: Number(ad_campaign_budget) * Number(ad_campaign_length),
                lead_ad_enabled: leadAdEnabled,
              });
            },
            (rr) => {
              Sentry.captureException(rr);
              lb(`Your Post Was Created, but Could Not Be Boosted <br><code>${JSON.stringify(rr)}</code>`, 'fail', r.post_id, null, true, true);
            },
          );
          lb('Please Wait While We Boost Your Post', 'loading', r.post_id, null, true, false);
        } else {
          lb('Your Post Was Created', 'success', r.post_id, null, true, true);
          FB.AppEvents.logEvent('post_only_created');
        }
      },
      (r) => {
        Sentry.captureException(r);
        lb(`Your Post Could Not Be Created <br><code>${JSON.stringify(r)}</code>`, 'fail', null, null, true, true);
      },
    );
    lb('It could take up to 30 seconds to create your post', 'loading', null, null, false, false);
  } else {
    data.hidden = true;
    jax(
      url,
      data,
      (r) => {
        jax(
          'create_ad_post',
          {
            page_id,
            account_id,
            fb_pixel_id: fb_pixel,
            db_post_id: r.db_post_id,
            object_story_spec: JSON.stringify(r.object_story_spec),
            link: ' ',
            daily_dollar: ad_campaign_budget,
            days: ad_campaign_length,
            targeting,
            name: campaignName,
            placement_options: JSON.stringify(placementOptions),
            schedule: JSON.stringify(send_ad_schedule),
            objective: leadAdEnabled ? 'OUTCOME_LEADS' : ad_campaign_objective,
            lead_ad_enabled: leadAdEnabled,
            lead_form_id: leadFormId,
            instagram_actor_id,
          },
          (rr) => {
            lb('Your Ad Was Created', 'success', rr.post_id, rr.campaign_id, true, true);
            FB.AppEvents.logEvent('ad_only_created', null, {
              ad_campaign_budget: Number(ad_campaign_budget),
              ad_campaign_length: Number(ad_campaign_length),
              total_spend: Number(ad_campaign_budget) * Number(ad_campaign_length),
              lead_ad_enabled: leadAdEnabled,
            });
          },
          (rr) => {
            Sentry.captureException(rr);
            lb(`Your Ad Could Not Be Created <br><code>${JSON.stringify(rr)}</code>`, 'fail', null, null, true, true);
          },
        );
        lb('Please Wait While We Create Your Ad', 'loading', null, null, null, null);
      },
      (r) => {
        Sentry.captureException(r);
        lb(`Your Ad Could Not Be Composed <br><code>${JSON.stringify(r)}</code>`, 'fail', null, null, true, true);
      },
    );
    lb('Please Wait While We Compose Your Ad', 'loading', null, null, false, false);
  }
}

export function loiter($dom, block, toggle, menu, timer, enter) {
  let loitering = false;
  $dom.find(`.${block}${toggle}`).on('mouseenter', (event) => {
    if (enter) {
      enter(event);
    }
    loitering = true;
    $dom.find(`.${block}${menu}`).removeClass('hide');
    $dom.find(`.${block}${toggle}`).addClass(`${block + toggle}--active`);
  });
  $dom.find(`.${block}${menu}`).on('mouseenter', () => { loitering = true; });
  $dom.find(`.${block}${menu}`).on('mouseleave', hide);
  $dom.find(`.${block}${toggle}`).on('mouseleave', hide);
  function hide() {
    loitering = false;
    setTimeout(() => {
      if (!loitering) {
        $dom.find(`.${block}${menu}`).addClass('hide');
        $dom.find(`.${block}${toggle}`).removeClass(`${block + toggle}--active`);
      }
    }, timer);
  }
}

export function get_ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return `${n}<sup>${s[(v - 20) % 10] || s[v] || s[0]}</sup>`;
}

export function storeSetting(key, value) {
  return new Promise((resolve, reject) => {
    jax(
      'set_domain_setting',
      { key, value },
      r => resolve(r),
      r => reject(r),
    );
  });
}

export function loadSetting(key) {
  return new Promise((resolve, reject) => {
    jax(
      'get_domain_setting',
      { key },
      r => resolve(r),
      r => reject(r),
    );
  });
}

// expected types: property, search, custom_link
export function checkLinkType(link, expected, type) {
  if (expected != type) {
    alert(
      `Using a ${type} on a ${expected} ad. \n`
      + `Redirecting you to ${type} ad.`,
    );
    window.onbeforeunload = null;
    window.location.assign(
      `${window.location.origin
      }/${type}.html`
      + `?link=${encodeURIComponent(link)}`,
    );
  }
}

export {
  params,
  override_lookup,
  ad_schedule_toggle,
  ad_schedule,
  get_server_url,
};
